export default __webpack_public_path__ + "static/media/spectacles-incorrect2.258e20dc.PNG";